import { Navigate, Route, Routes } from 'react-router-dom';
import ModuleLayout from '@/components/module/ModuleLayout';
import ShippingContainerIcon from '@/components/icons/ShippingContainerIcon';
import { Building2 } from 'lucide-react';
import DepotDashboard from '@/pages/depot/DepotDashboard';
import DepotAccountsPage from '@/pages/depot/DepotAccountsPage';
import DepotProfitabilityPage from '@/pages/depot/DepotProfitabilityPage';
import DepotRevenuePage from '@/pages/depot/DepotRevenuePage';
import DepotTariffPage from '@/pages/depot/DepotTariffPage';
import DepotGatePage from '@/pages/depot/DepotGatePage';
import DepotYardPage from '@/pages/depot/DepotYardPage';
import DepotContainersPage from '@/pages/depot/DepotContainersPage';
import DepotInspectionsPage from '@/pages/depot/DepotInspectionsPage';
import DepotMovesPage from '@/pages/depot/DepotMovesPage';
import DepotMaintenancePage from '@/pages/depot/DepotMaintenancePage';
import DepotBillingPage from '@/pages/depot/DepotBillingPage';
import DepotExternalAccessPage from '@/pages/depot/DepotExternalAccessPage';
import DepotReportsPage from '@/pages/depot/DepotReportsPage';
import DepotSetupPage from '@/pages/depot/DepotSetupPage';

function DepotLayout() {
  return (
    <ModuleLayout
      title="Depot"
      subtitle="Ops · Accounts · Revenue · Billing"
      icon={Building2}
      accentColor="text-orange-700"
      moduleId="depot"
    />
  );
}

export default function DepotRoutes() {
  return (
    <Routes>
      <Route element={<DepotLayout />}>
        <Route index element={<DepotDashboard />} />
        <Route path="accounts" element={<DepotAccountsPage />} />
        <Route path="external-access" element={<DepotExternalAccessPage />} />
        <Route path="profitability" element={<DepotProfitabilityPage />} />
        <Route path="revenue" element={<DepotRevenuePage />} />
        <Route path="tariff" element={<DepotTariffPage />} />
        <Route path="gate" element={<DepotGatePage />} />
        <Route path="yard" element={<DepotYardPage />} />
        <Route path="containers" element={<DepotContainersPage />} />
        <Route path="inspections" element={<DepotInspectionsPage />} />
        <Route path="moves" element={<DepotMovesPage />} />
        <Route path="maintenance" element={<DepotMaintenancePage />} />
        <Route path="billing" element={<DepotBillingPage />} />
        <Route path="reports" element={<DepotReportsPage />} />
        <Route path="setup" element={<DepotSetupPage />} />
        <Route path="*" element={<Navigate to="/depot" replace />} />
      </Route>
    </Routes>
  );
}
